// The editor body default font size (px). Must stay in lockstep with
// `.content { font-size: 15px }` in PlateEditor.module.scss — the CSS value is
// the source of truth for rendering; this constant mirrors it for the JS layer
// (FontSizeMenu default selection, legacy-size normalization).
export const BODY_DEFAULT_FONT_SIZE_PX = 15;
